
export function fixViewportHeight() {
  function updateVh() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const isKeyboardOpen = window.innerHeight < window.outerHeight - 100;
    document.body.classList.toggle('keyboard-open', isKeyboardOpen);
  }

  updateVh(); // set once
  window.addEventListener('resize', updateVh); // on resize or orientation change
}
